// extracted by mini-css-extract-plugin
module.exports = {"item":"item--22Qdc","textWrap":"textWrap--1WQAX","describe":"describe--1TNcl","aside":"aside--1JoD_","plan":"plan--2eJzn","imageWrap":"imageWrap--17qLE","tabs":"tabs--2kjBA"};